import { useSelector, useDispatch } from 'react-redux';
import { setEventData } from '../../Redux/store';
import EventDisplay from './EventDisplay';
import ModalWrapper from '../../components/ModalWrapper';
import CloseButton from '../../components/CloseButton';

/**
 * EventMenu - Modal wrapper for creating/editing a calendar event.
 * Uses EventDisplay for the content.
 */
function EventMenu() {
  const dispatch = useDispatch();
  const eventData = useSelector((s) => s.ui.eventData);

  if (!eventData) return null;

  const close = () => {
    dispatch(setEventData(null));
  };

  const handleCreateNew = (newEventData) => {
    dispatch(setEventData(newEventData));
  };

  return (
    <ModalWrapper onClose={close} height="h-[95%]">
      {/* Fixed top header */}
      <div className="p-5 flex items-center justify-between flex-shrink-0">
        <h3 className="text-lg font-semibold">{new Date(eventData.date + 'T00:00').toLocaleDateString(undefined, {
          weekday: 'long', month: 'long', day: 'numeric',
        })}</h3>
        <CloseButton onClose={close} />
      </div>
      <EventDisplay eventData={eventData} onClose={close} onCreateNew={handleCreateNew} />
    </ModalWrapper>
  );
}

export default EventMenu;
